module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$route.path.indexOf('_detail') === -1) ? _c('div', [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "md": 8,
      "lg": 6
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "手机号/订单号",
      "size": "mini"
    },
    model: {
      value: (_vm.mobile),
      callback: function($$v) {
        _vm.mobile = $$v
      },
      expression: "mobile"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.numberSearch
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 10,
      "lg": 8
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "daterange",
      "start-placeholder": "开始时间",
      "ange-separator": "至",
      "end-placeholder": "结束时间",
      "value-format": "yyyy/MM/dd",
      "placeholder": "选择日期范围",
      "size": "mini"
    },
    on: {
      "change": _vm.dateChange
    },
    model: {
      value: (_vm.timeRange),
      callback: function($$v) {
        _vm.timeRange = $$v
      },
      expression: "timeRange"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('div', {
    staticClass: "btn-2"
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 8,
      "lg": 6
    }
  }, [_c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary"
    },
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("导出")]), _vm._v(" "), _c('el-popover', {
    attrs: {
      "placement": "top-start",
      "width": "200",
      "trigger": "hover",
      "content": "导出任务会以队列执行，点击导出后，请至‘设置-导出列表’页面中查看及下载数据"
    }
  }, [_c('i', {
    staticClass: "el-icon-question",
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  })])], 1)], 1), _vm._v(" "), _c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "待确认",
      "name": "0"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "找药中",
      "name": "1"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "结果",
      "name": "2,3"
    }
  }), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.list,
      "height": _vm.wheight - 200
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "created",
      "width": "160",
      "label": "创建时间"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("datetime")(scope.row.created, 'yyyy-MM-dd hh:mm:ss')))])]
      }
    }], null, false, 2445216850)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "medicine_id",
      "width": "160",
      "label": "需求单号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "medicine_name",
      "label": "药品名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "spec",
      "label": "规格"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "producer",
      "label": "生产厂商"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "num",
      "label": "数量"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "distributor",
      "label": "店铺"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sale_mobile",
      "label": "员工电话"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "顾客"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "mobile",
      "label": "顾客手机号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "address",
      "label": "地址"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "remarks",
      "label": "备注"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "img",
      "label": "图片"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._l((scope.row.imgs), function(x, k) {
          return [_c('el-popover', {
            attrs: {
              "placement": "right",
              "width": "240",
              "trigger": "hover"
            }
          }, [_c('img', {
            staticStyle: {
              "width": "100%"
            },
            attrs: {
              "src": x
            }
          }), _vm._v(" "), _c('el-button', {
            attrs: {
              "slot": "reference",
              "type": "text"
            },
            slot: "reference"
          }, [_c('img', {
            attrs: {
              "src": "/static/img/icon_img.png"
            }
          })])], 1)]
        })]
      }
    }], null, false, 2920134202)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "状态"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status == 0) ? _c('el-tag', {
          attrs: {
            "size": "mini"
          }
        }, [_vm._v("待确认")]) : (scope.row.status == 1) ? _c('el-tag', {
          attrs: {
            "type": "danger",
            "size": "mini"
          }
        }, [_vm._v("找药中")]) : (scope.row.status == 2) ? _c('el-tag', {
          attrs: {
            "type": "success",
            "size": "mini"
          }
        }, [_vm._v("已找到")]) : (scope.row.status == 3) ? _c('el-tag', {
          attrs: {
            "type": "warning",
            "size": "mini"
          }
        }, [_vm._v("未找到")]) : _vm._e()]
      }
    }], null, false, 1907533524)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status == 0) ? _c('div', [(scope.row.status == 0) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.dialogOpen(scope.row.id, 1)
            }
          }
        }, [_vm._v("确 认")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (scope.row.status == 1) ? _c('div', [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "success"
          },
          on: {
            "click": function($event) {
              return _vm.dialogOpen(scope.row.id, 2)
            }
          }
        }, [_vm._v("已找到")]), _vm._v(" "), _c('div', {
          staticClass: "btn-2"
        }), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.dialogOpen(scope.row.id, 3)
            }
          }
        }, [_vm._v("未找到")])], 1) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
          staticClass: "btn-2"
        }), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "info"
          },
          on: {
            "click": function($event) {
              return _vm.dialogCancel(scope.row.id, scope.row.status)
            }
          }
        }, [_vm._v("备注")])], 1)]
      }
    }], null, false, 879059914)
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content-padded content-center"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "total, sizes, prev, pager, next",
      "current-page": _vm.params.page,
      "page-sizes": [10, 20, 50],
      "total": _vm.total_count,
      "page-size": _vm.params.pageSize
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      }
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "备注",
      "visible": _vm.canceldialog,
      "close-on-click-modal": false,
      "width": "50%"
    },
    on: {
      "update:visible": function($event) {
        _vm.canceldialog = $event
      }
    }
  }, [_c('section', {
    staticClass: "section section-white content-padded",
    attrs: {
      "onload": "init()"
    }
  }, [_c('h2', {
    staticClass: "delog-h2"
  }, [_vm._v("状态：" + _vm._s(_vm.massage))]), _vm._v(" "), _c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "110px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "回复顾客前后台可见",
      "prop": "source_video_type"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "请输入要回复的内容"
    },
    model: {
      value: (_vm.form.home_msg),
      callback: function($$v) {
        _vm.$set(_vm.form, "home_msg", $$v)
      },
      expression: "form.home_msg"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "新增备注进后台可见",
      "prop": "source_video_type"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "请输入备注内容"
    },
    model: {
      value: (_vm.form.admin_msg),
      callback: function($$v) {
        _vm.$set(_vm.form, "admin_msg", $$v)
      },
      expression: "form.admin_msg"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer content-center",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.canceldialog = false;
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.addPostMsg()
      }
    }
  }, [_vm._v("确认提交")])], 1)], 1), _vm._v(" "), _c('el-tabs', {
    attrs: {
      "type": "border-card"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "管理员回复日志（前台只展示最新一条回复内容）",
      "name": "0"
    }
  }), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingList),
      expression: "loadingList"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.form_list,
      "label": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "admin_text",
      "label": "信息:"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(scope.row.home_text)
          }
        })]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-tabs', {
    attrs: {
      "type": "border-card"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "管理员备注日志",
      "name": "0"
    }
  }), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingList),
      expression: "loadingList"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.form_list,
      "label": "管理员备注日志"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "admin_text",
      "label": "信息:"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(scope.row.admin_text)
          }
        })]
      }
    }])
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-56d3ef9c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-56d3ef9c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/mall/trade/finddrug.vue
// module id = 2729
// module chunks = 0